// import React from 'react';
// import ReactDOM from 'react-dom/client';
// import './index.css';
// import App from './App';
// import reportWebVitals from './reportWebVitals';
// import { BrowserRouter } from 'react-router-dom';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import './styles/styles.css';


// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   <React.StrictMode>
//     <BrowserRouter>
//       <App />
//     </BrowserRouter>
//   </React.StrictMode>
// );

// // If you want to start measuring performance in your app, pass a function
// // to log results (for example: reportWebVitals(console.log))
// // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();

// import React from 'react';
// import ReactDOM from 'react-dom/client';
// import './index.css';
// import App from './App';
// import reportWebVitals from './reportWebVitals';
// import { BrowserRouter } from 'react-router-dom';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import './styles/styles.css';
// import { Capacitor } from '@capacitor/core';
// import { Purchases } from '@revenuecat/purchases-capacitor';
// import * as Sentry from '@sentry/react';

// Sentry.init({
//   dsn: process.env.REACT_APP_SENTRY_DSN,
//   environment: process.env.NODE_ENV,
  
//   // Send bare 20% av vanlige events i prod for å spare quota
//   tracesSampleRate: process.env.NODE_ENV === 'production' ? 0.2 : 1.0,
  
//   // Ignorer støy vi ikke bryr oss om
//   ignoreErrors: [
//     'ResizeObserver loop limit exceeded',
//     'Network request failed',
//     'Load failed',
//   ],
// });

// const initializeRevenueCat = async () => {
//   if (Capacitor.isNativePlatform()) {
//     const apiKey = Capacitor.getPlatform() === 'ios' 
//       ? 'appl_NUzkxeLoyOWNYaYOerdtDfziPNu'
//       : 'your_android_api_key_here';

//     await Purchases.configure({ apiKey });
//     console.log('RevenueCat SDK initialized');
//   } else {
//     console.log('RevenueCat SDK not initialized (not running on a native platform)');
//   }
// };

// const renderApp = () => {
//   const root = ReactDOM.createRoot(document.getElementById('root'));
//   root.render(
//       <BrowserRouter>
//         <App />
//       </BrowserRouter>
//   );

//   // If you want to start measuring performance in your app, pass a function
//   // to log results (for example: reportWebVitals(console.log))
//   // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//   reportWebVitals();
// };

// // Initialize RevenueCat before rendering the app
// initializeRevenueCat().then(renderApp);


import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/styles.css';
import { Capacitor } from '@capacitor/core';
import { Purchases } from '@revenuecat/purchases-capacitor';
import * as Sentry from '@sentry/react';

Sentry.init({
  dsn: "https://ba2979f33a0f25f3433787261f4435ef@o4509865249931264.ingest.de.sentry.io/4510971420082256",
  environment: process.env.NODE_ENV,
  sendDefaultPii: true,
  tracesSampleRate: process.env.NODE_ENV === 'production' ? 0.2 : 1.0,
  ignoreErrors: [
    'ResizeObserver loop limit exceeded',
    'Network request failed',
    'Load failed',
  ],
});

const initializeRevenueCat = async () => {
  if (Capacitor.isNativePlatform()) {
    const apiKey = Capacitor.getPlatform() === 'ios' 
      ? 'appl_NUzkxeLoyOWNYaYOerdtDfziPNu'
      : 'your_android_api_key_here';

    await Purchases.configure({ apiKey });
    console.log('RevenueCat SDK initialized');
  } else {
    console.log('RevenueCat SDK not initialized (not running on a native platform)');
  }
};

const renderApp = () => {
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <Sentry.ErrorBoundary fallback={<p>Noe gikk galt. Last inn appen på nytt.</p>}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Sentry.ErrorBoundary>
  );

  reportWebVitals();
};

initializeRevenueCat().then(renderApp);